import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../app/store';

export interface ContactInfoState {
    salutation: string,
    firstName: string,
    lastName: string,
    title: string,
    phoneNum: string,
    mobileNum: string,
    email: string,
    compName: string,
    compAddress: string,
    compSize: string,
    industry: string,
    platform: boolean[],
    declaration: boolean,
    [index: string | number]: any
}

const initialState: ContactInfoState = {
    salutation: "",
    firstName: "",
    lastName: "",
    title: "",
    phoneNum: "",
    mobileNum: "",
    email: "",
    compName: "",
    compAddress: "",
    compSize: "",
    industry: "",
    platform: [false, false, false, false, false],
    declaration: false,
};

export const contactInfoSlice = createSlice({
    name: 'contactInfo',
    initialState,
    reducers: {
        update: (state, action) => {
            switch (action.payload.type) {
                case "Salutation":
                    state.salutation = action.payload.value;
                    break;
                case "First Name":
                    state.firstName = action.payload.value;
                    break;
                case "Last Name":
                    state.lastName = action.payload.value;
                    break;
                case "Title":
                    state.title = action.payload.value;
                    break;
                case "Phone Number":
                    state.phoneNum = action.payload.value;
                    break;
                case "Mobile Number":
                    state.mobileNum = action.payload.value;
                    break;
                case "Email":
                    state.email = action.payload.value;
                    break;
                case "Company Name":
                    state.compName = action.payload.value;
                    break;
                case "Company Address":
                    state.compAddress = action.payload.value;
                    break;
                case "Company Size":
                    state.compSize = action.payload.value;
                    break;
                case "Industry":
                    state.industry = action.payload.value;
                    break;
                case "Platform":
                    state.platform[action.payload.index] = !state.platform[action.payload.index];
                    break;
                case "Declaration Checked":
                    state.declaration = action.payload.value;
                    break;
                default: return;
            }
        },
    },
});

export const { update } = contactInfoSlice.actions;

export const selectContactInfo = (state: RootState) => state.contactInfo;

export default contactInfoSlice.reducer;